module.exports = __webpack_public_path__ + "static/fonts/lato-v23-latin-ext_latin-100.736b697.woff2";